<template>

    <div class="pt-5 pb-5 text-left">
        <div v-if="compact" class="compact">
            <span>1 Konservierungsstoff, </span>
            <span>2 Geschmacksver., </span>
            <span>3 Antioxidationsmittel, </span>
            <span>4 Farbstoff, </span>
            <span>5 Phosphat, </span>
            <span>6 Chinin, </span>
            <span>7 Koffein, </span>
            <span>8 geschwefelt, </span>
            <span>9 Saccharin, </span>
            <span>10 Aspartam/ Phenyl., </span>
            <span>11 Cyclamat, </span>
            <span>12 Acesulfam, </span>
            <span>13 geschwärzt, </span>
            <span>14 gewachst, </span>
            <span>15 gentechnisch, </span>

            <span>GL Gluten, </span>
            <span>EI Ei, </span>
            <span>ER Erdnüsse, </span>
            <span>FI Fisch, </span>
            <span>KR Krebstiere, </span>
            <span>LU Lupine, </span>
            <span>MI Milch, </span>
            <span>SC Schalenfrüchte, </span>
            <span>SL Sellerie, </span>
            <span>SF Senf, </span>
            <span>SE Sesamen, </span>
            <span>SJ Soja, </span>
            <span>WE Weichtiere</span>
        </div>
        <div v-else>
            <v-layout row wrap class="myLegend">
                <v-flex xs6 class="pa-2">
                    <h3>Zusatzstoffe</h3>
                    <span>1 Konservierungsstoff</span>
                    <span>2 Geschmacksver.</span>
                    <span>3 Antioxidationsmittel</span>
                    <span>4 Farbstoff</span>
                    <span>5 Phosphat</span>
                    <span>6 Chinin</span>
                    <span>7 Koffein</span></span>
                    <span>8 geschwefelt</span>
                    <span>9 Saccharin</span>
                    <span>10 Aspartam/ Phenyl.</span>
                    <span>11 Cyclamat</span>
                    <span>12 Acesulfam</span>
                    <span>13 geschwärzt</span>
                    <span>14 gewachst</span>
                    <span>15 gentechnisch</span>
                </v-flex>
                <v-flex xs6 class="pa-2 pr-4">
                    <h3>Allergene</h3>
                    <span>A Gluten</span>
                    <span>B Krebstiere</span>
                    <span>C Eier von Geflügel</span>
                    <span>D Fisch</span>
                    <span>E Erdnüsse</span>
                    <span>F Sojabohnen</span>
                    <span>G Milch und Milcherzeugnisse</span>
                    <span>H Schalenfrüchte</span>
                    <span>L Sellerie</span>
                    <span>M Senf</span>
                    <span>N Sesamen</span>
                    <span>O Schwefeloxid und Sulfite</span>
                    <span>P Lupinen</span>
                    <span>R Weichtiere</span>
                    <div class="badges mt-5">
                        <img class="mr-3"
                             src="../assets/icons/vegi.png"
                             alt="Vegetarisch"
                        >
                        <img class="mr-3"
                             src="../assets/icons/vegan-140.png"
                             alt="Vegan"
                        >
                    </div>
                    <!--                    <v-img-->
                    <!--                            class="mt-5"-->
                    <!--                            style="max-width 300px"-->
                    <!--                            src="https//skapps.s3.eu-central-1.amazonaws.com/mrbens/images/t/veganIcons.png">-->
                    <!--                    </v-img>-->
                </v-flex>
            </v-layout>
        </div>
    </div>

</template>

<script>
    export default {
        name: "AllergenLegende",
        props: {
            compact: {
                type: Boolean,
                default: true
            },
        },
        methods: {}
    }
</script>

<style scoped lang="scss">
    .badges{
        height: 62px;
        text-align: left;
        img {
            display: inline-block;
            width: auto;
            height: 62px;
        }
    }

    .compact {
        span {
            white-space: nowrap;
            display: inline-block;
            margin-right: 3px;
        }
    }

    .myLegend {
        span {
            white-space: nowrap;
            display: block;
        }
    }
</style>